<template>
  <v-content>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card style="padding-bottom: 200px">
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <span style="font-weight: bold">PROFILE (ข้อมูลส่วนตัว)</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-list>
          <v-list-item style="top: 100px">
            <v-row class="d-flex justify-center">
              <v-col raised cols="12" md="4">
                <v-card>
                  <div class="white--text align-end" style="height: 200px;background-color: lightskyblue">
                    <v-list-item style="top: -80px" class="justify-center">
                      <v-avatar size="200" style="border: darkcyan 4px solid">
                        <img :src="mednet" alt="-">
                      </v-avatar>
                    </v-list-item>
                  </div>
                  <v-list-item style="top: -50px" class="justify-center">
                    <span style="font-weight: bold;font-size: 25px" v-if="MeData.length > 0">
                      {{ (MeData.length > 0 ? MeData[0].full_Name: '') }}
                    </span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81">
                      สังกัด
                    </span>
                    <span v-if="MeData.length > 0">: {{ MeData[0].dep_name }}</span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81">
                      ตำแหน่ง
                    </span>
                    <span v-if="MeData.length > 0">: {{ MeData[0].pos_name }}</span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81">
                      อายุงาน
                    </span>
                    <span v-if="workAge.length > 0" style="margin-left: 10px">: {{ workAge[0] }} ปี {{ workAge[1] }}
                      เดือน {{ workAge[2] }} วัน</span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                      ระดับ
                    </span>
                    <span style="margin-left: 10px" v-if="level.length > 0">: {{ level[0].LevelName }}</span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                      งบพัฒนาตนเองใช้ไป
                    </span>
                    <span style="margin-left: 10px">: -</span>
                  </v-list-item>
                  <v-list-item class="start">
                    <span style="font-weight: bold;color: #ff6d81" v-if="MeData.length > 0">
                      งบพัฒนาตนเองคงเหลือ
                    </span>
                    <span style="margin-left: 10px">: -</span>
                  </v-list-item>
                </v-card>
                <v-divider>

                </v-divider>
                <v-card style="top: 20px">
                  <v-toolbar dark color="#64B5F6">
                    <v-toolbar-title>
                      การเลื่อนขั้น
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text style="top: 10px" class="text-center">
                    <span style="color: #364eff;font-weight: bold;text-align: center;width: 100%;font-size: 25px">Coming
                      Soon</span>
                  </v-card-text>
                  <!-- <v-list-item
                           class="start"
                   >
               <span style="font-weight: bold;color: #ff6d81">
                   ระดับขั้นถัดไป
               </span>
                       : ชำนาญการพิเศษ
                   </v-list-item>
                   <v-list-item
                           class="start"
                   >
                       <p style="font-weight: bold;color: #ff6d81">
                           หลักสูตร: <span style="color: darkblue"> 4 หลักสูตร</span> ( <span
                               style="color: darkseagreen"> ผ่าน 2 </span> , <span style="color: crimson"> ขาด 2 </span>)
                       </p>
                   </v-list-item>
                   <v-divider></v-divider>
                   <v-list-item
                           class="start"
                   >
                       <p style="font-weight: bold;color: #ff6d81">
                           คิดเป็นเป็นเซ็นต์ : <span style="color: darkblue">50 %</span>
                       </p>
                   </v-list-item>
                   <v-list-item style="top: 20px;">
                       <v-slider
                               v-model="bpm"
                               :color="color"
                               track-color="grey"
                               always-dirty
                               min="0"
                               max="100"
                               thumb-label="always"
                       >
                           <template v-slot:prepend>
                           <span style="font-weight: bold;color: darkblue">
                               0%
                           </span>
                           </template>

                           <template v-slot:append>
                           <span style="font-weight: bold;color: darkblue">
                               100%
                           </span>
                           </template>
                       </v-slider>
                   </v-list-item>-->
                </v-card>

              </v-col>
              <v-col cols="12" md="7">
                <v-card>
                  <v-toolbar color="#64B5F6">
                    <v-toolbar-title>
                      <v-tabs v-model="tabMenu" color="#64B5F6" bg-color="primary" centered
                        style="background-color: #364eff;">
                        <v-tab value="1">
                          <v-icon left>mdi-school</v-icon>
                          <span class="font-weight-bold">คอร์สที่ต้องเรียน</span>
                        </v-tab>
                        <v-tab value="2">
                          <v-icon left>mdi-history</v-icon>
                          <span class="font-weight-bold">ประวัติการอบรม</span>
                        </v-tab>
                      </v-tabs>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text style="top: 10px" class="text-center">
                    <v-tabs-items v-model="tabMenu">
                      <v-tab-item key="1">
                        <template v-if="CourseInit.length == 0">
                          <span class="font-weight-bold"
                            style="color: #364eff;font-size: 20px">ไม่มีคอร์สที่ต้องเรียน</span>
                        </template>
                        <template v-else>
                          <v-row>
                            <v-col cols="12" md="6" lg="4" v-for="(item, index) in CourseInit.slice(0, 4)"
                              :key="'course-preview-' + index">
                              <v-card class="mb-2">
                                <template v-if="item.image && item.image.trim() !== ''">
                                  <v-img :src="item.image" height="200px" class="white--text align-end"></v-img>
                                </template>
                                <template v-else>
                                  <div style="height: 200px; width: 100%; display: flex; align-items: center; justify-content: center;">
                                    <svg width="100%" height="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400">
                                      <defs>
                                        <!-- Gradient backgrounds -->
                                        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                          <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                          <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
                                        </linearGradient>
                                        
                                        <!-- Text gradient -->
                                        <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                          <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                          <stop offset="50%" style="stop-color:#764ba2;stop-opacity:1" />
                                          <stop offset="100%" style="stop-color:#f093fb;stop-opacity:1" />
                                        </linearGradient>
                                        
                                        <!-- Line gradient -->
                                        <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                          <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                          <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
                                        </linearGradient>
                                        
                                        <!-- Drop shadow filter -->
                                        <filter id="dropshadow" x="-50%" y="-50%" width="200%" height="200%">
                                          <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
                                          <feOffset dx="2" dy="4" result="offset" />
                                          <feComponentTransfer>
                                            <feFuncA type="linear" slope="0.3"/>
                                          </feComponentTransfer>
                                          <feMerge> 
                                            <feMergeNode/>
                                            <feMergeNode in="SourceGraphic"/> 
                                          </feMerge>
                                        </filter>
                                      </defs>
                                      
                                      <!-- Background -->
                                      <rect width="100%" height="100%" fill="url(#bgGradient)" rx="20"/>
                                      
                                      <!-- Background card -->
                                      <rect x="100" y="80" width="600" height="240" fill="rgba(255,255,255,0.95)" 
                                            rx="15" stroke="rgba(255,255,255,0.3)" stroke-width="1" 
                                            filter="url(#dropshadow)"/>
                                      
                                      <!-- Main text -->
                                      <text x="400" y="180" text-anchor="middle" 
                                            font-family="Sarabun, Arial, sans-serif" 
                                            font-size="72" 
                                            font-weight="700" 
                                            fill="url(#textGradient)"
                                            filter="url(#dropshadow)">
                                        คอร์สกิจกรรม
                                        <animateTransform attributeName="transform" type="scale" 
                                                          values="1;1.02;1" dur="3s" repeatCount="indefinite"/>
                                      </text>
                                      
                                      <!-- Decorative line -->
                                      <rect x="350" y="210" width="100" height="4" fill="url(#lineGradient)" rx="2">
                                        <animateTransform attributeName="transform" type="scale" 
                                                          values="1,1;1.1,1;1,1" dur="2s" repeatCount="indefinite"/>
                                      </rect>
                                      
                                      <!-- Subtitle -->
                                      <text x="400" y="250" text-anchor="middle" 
                                            font-family="Sarabun, Arial, sans-serif" 
                                            font-size="20" 
                                            font-weight="400" 
                                            fill="#666">
                                        Course Activities
                                      </text>
                                      
                                      <!-- Decorative elements -->
                                      <circle cx="150" cy="120" r="3" fill="rgba(255,255,255,0.6)">
                                        <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite"/>
                                      </circle>
                                      <circle cx="650" cy="280" r="2" fill="rgba(255,255,255,0.5)">
                                        <animate attributeName="opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite"/>
                                      </circle>
                                      <circle cx="180" cy="300" r="1.5" fill="rgba(255,255,255,0.4)">
                                        <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2.5s" repeatCount="indefinite"/>
                                      </circle>
                                    </svg>
                                  </div>
                                </template>
                                <v-card-title>
                                  <span class="font-weight-bold">{{ item.title.length > 25 ? item.title.substring(0, 25)
                                    + '...' : item.title }}</span>
                                </v-card-title>
                                <v-card-actions class="justify-center">
                                  <v-btn color="primary" @click="GetCourseToShow(item)">
                                    <v-icon left>mdi-eye</v-icon>
                                    ดูรายละเอียด
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                          <v-row v-if="CourseInit.length > 6" class="mt-4">
                            <v-col class="text-center">
                              <v-btn color="primary" @click="openAllCoursesDialog">
                                แสดงรายละเอียดทั้งหมด
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>
                        <!-- 
                          To make the "แสดงรายละเอียดทั้งหมด" button functional, you would add a dialog:
                          1. Add a data property: `allCoursesDialog: false`
                          2. Add a method: `openAllCoursesDialog() { this.allCoursesDialog = true; }`
                          3. Add a v-dialog component in your template, for example:
                           <v-dialog v-model="allCoursesDialog" fullscreen scrollable>
                             <v-card>
                             <v-toolbar dark color="primary">
                               <v-btn icon dark @click="allCoursesDialog = false">
                               <v-icon>mdi-close</v-icon>
                               </v-btn>
                               <v-toolbar-title>คอร์สทั้งหมด</v-toolbar-title>
                             </v-toolbar>
                             <v-card-text>
                               <v-row>
                               <v-col cols="12" md="4" v-for="(item, index) in CourseInit" :key="'all-course-' + index">
                                 <v-card class="mb-2">
                                 <v-img :src="item.image" height="200px" class="white--text align-end"></v-img>
                                 <v-card-title>
                                   <span class="font-weight-bold">{{ item.title }}</span>
                                 </v-card-title>
                                 <v-card-actions class="justify-center">
                                   <v-btn color="primary" @click="GetCourseToShow(item)">
                                   <v-icon left>mdi-eye</v-icon>
                                   ดูรายละเอียด
                                   </v-btn>
                                 </v-card-actions>
                                 </v-card>
                               </v-col>
                               </v-row>
                             </v-card-text>
                             </v-card>
                           </v-dialog>
                        -->
                      </v-tab-item>
                      <v-tab-item key="2">
                        <div align="center" style="margin-top: 20px">
                          <v-btn color="primary" @click="TrainDataToShow">
                            <v-icon left>mdi-eye</v-icon>
                            แสดงรายละเอียด
                          </v-btn>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
      </v-card>
      <v-dialog v-model="dialogTrainData" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
        <v-card tile>
          <v-app-bar absolute color="#6A76AB" dark shrink-on-scroll prominent
            src="https://picsum.photos/1920/1080?random" fade-img-on-scroll scroll-target="#scrolling-techniques-3">
            <template v-slot:img="{ props }">
              <v-img v-bind="props" gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)"></v-img>
            </template>

            <v-btn icon dark @click="dialogTrainData = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>

            <span v-if="staff_sel != null">{{ (MeData.length > 0 ? MeData[0].full_Name: '') }} ({{ staff_sel.perid }})</span>

            <v-spacer></v-spacer>

            <v-avatar size="100px" v-if="staff_sel != null" style="border: 5px solid antiquewhite">
              <img :src="'https://medhr.medicine.psu.ac.th/ImageMED.php?pid=' + staff_sel.perid"
                :alt="(MeData.length > 0 ? MeData[0].full_Name: '')">
            </v-avatar>

            <template v-slot:extension>
              <v-tabs align-with-title v-model="tab">
                <v-tab href="#tab-2" style="font-size: 16px">ฝึกอบรม</v-tab>
                <v-tab href="#tab-3" style="font-size: 16px">คณะกรรมการ</v-tab>
                <v-tab href="#tab-4" style="font-size: 16px">วิทยากร / อาจารย์พิเศษ / นำเสนอผลงาน</v-tab>
                <v-tab href="#tab-5" style="font-size: 16px">บทความ</v-tab>
                <v-tab href="#tab-6" style="font-size: 16px">รางวัลพิเศษ</v-tab>
                <v-tab></v-tab>
              </v-tabs>
            </template>
          </v-app-bar>
          <v-sheet id="scrolling-techniques-3" class="overflow-y-auto">
            <v-container style="height: 250px;"></v-container>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-2">
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาโครงการ" v-model="searchTrain"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateSTrain" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateStart" no-title
                        @input="showPickerSearchDateSTrain = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateETrain" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateEnd" no-title
                        @input="showPickerSearchDateETrain = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('0')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestoreTrain">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
                    worksheet="ประวัติ พัฒนา/ฝึกอบรม/การศึกษา"
                    :name="'ข้อมูลประวัติ พัฒนา/ฝึกอบรม/การศึกษา คุณ ' + (MeData.length > 0 ? MeData[0].full_Name: '') + '.xls'">
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list three-line subheader>
                  <v-subheader>พัฒนา / ฝึกอบรม</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <!--                    <v-data-table-->
                      <!--                        :headers="TrainHeader"-->
                      <!--                        :items="TrainHistory"-->
                      <!--                        show-expand-->
                      <!--                        :expanded.sync="expanded"-->
                      <!--                        :single-expand="singleExpand"-->
                      <!--                        item-key="idx"-->
                      <!--                    >-->
                      <v-data-table :headers="TrainHeader" :items="TrainHistory" item-key="idx"
                        :sort-by="['date_start']" :sort-desc="[true]" :search="searchTrain">
                        <!--                        <template v-slot:item="{ item, expand, isExpanded }">-->
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>

                          <tr v-else>
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length">
                            <div v-for="(file, idx) in item.files" v-bind:key="idx">
                              {{ item.files }}
                              <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ :
                                {{ file.File_name }}
                              </v-btn>
                            </div>
                          </td>
                        </template>
                        <!--                      <template v-slot:item.date_start="{item}">-->
                        <!--                        <span>-->
                        <!--                          {{ item.date_start | dateToThai }}-->
                        <!--                        </span>-->
                        <!--                      </template>-->
                        <!--                      <template v-slot:item.date_end="{item}">-->
                        <!--                        <span>-->
                        <!--                          {{ item.date_end | dateToThai }}-->
                        <!--                        </span>-->
                        <!--                      </template>-->
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
              </v-tab-item>
              <v-tab-item value="tab-3">
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาคณะกรรมการ" v-model="searchCommit"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateSCommit" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateStart" no-title
                        @input="showPickerSearchDateSCommit = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateECommit" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateEnd" no-title
                        @input="showPickerSearchDateECommit = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('1')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestoreCommitt">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
                    worksheet="ประวัติกรรมการ" :name="'ข้อมูลประวัติ กรรมการ คุณ ' + (MeData.length > 0 ? MeData[0].full_Name: '') + '.xls'">
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list three-line subheader>
                  <v-subheader>คณะกรรมการ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table :headers="TrainHeader" :items="CommitHistory" :sort-by="['date_start']"
                        :sort-desc="[true]" :search="searchCommit" item-key="idx">
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                          <tr v-else>
                            <!--                            <td>-->
                            <!--                              <v-btn @click="expand(!isExpanded)" text color="primary">ไฟล์</v-btn>-->
                            <!--                            </td>-->
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item value="tab-4">
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาวิทยากร,อาจารย์พิเศษ,นำเสนอผลงาน" v-model="searchPresent"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateSPresent" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateStart" no-title
                        @input="showPickerSearchDateSPresent = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <template>
                    <v-menu v-model="showPickerSearchDateEPresent" :close-on-content-click="false"
                      transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" hint="YYYY/MM/DD" persistent-hint
                          readonly v-on="on"></v-text-field>
                      </template>
                      <v-date-picker locale="th" v-model="searchDateEnd" no-title
                        @input="showPickerSearchDateEPresent = false"></v-date-picker>
                    </v-menu>
                  </template>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="filterDate('2')">
                    ค้นหา
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn outlined color="primary" @click="RestorePresent">
                    แสดงทั้งหมด
                  </v-btn>
                  <v-spacer></v-spacer>
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields"
                    worksheet="วิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน"
                    :name="'ข้อมูลประวัติ วิทยากร/อาจารย์พิเศษ/นำเสนอผลงาน คุณ ' + (MeData.length > 0 ? MeData[0].full_Name: '') + '.xls'"
                    v-if="staff_sel != null">
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list three-line subheader>
                  <v-subheader>วิทยากร / อาจารย์พิเศษ / นำเสนอผลงาน</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table :headers="TrainHeader" :items="PresentHistory" :sort-by="['date_start']"
                        :sort-desc="[true]" :search="searchPresent">
                        <template v-slot:item="{ item }">
                          <tr style="cursor: pointer" @click="ShowDetailData(item)" v-if="item.Train_Type == 'Custom'">
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.objData.CustomDetail != '' && item.objData.CustomDetail != null">
                                <div v-html="item.objData.CustomDetail"></div>
                                <template v-if="item.Rm != ''">
                                  <v-divider></v-divider>
                                  {{ item.Rm }}
                                </template>
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                          <tr v-else>
                            <!--                            <td>-->
                            <!--                              <v-btn @click="expand(!isExpanded)" text color="primary">ไฟล์</v-btn>-->
                            <!--                            </td>-->
                            <td v-if="item.date_start != '0000-00-00'">
                              {{ item.date_start | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td v-if="item.date_end != '0000-00-00'">
                              {{ item.date_end | dateToThai }}
                            </td>
                            <td v-else></td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Subject }}</span>
                              <div v-if="item.objData.CustomDetail != '' && item.objData.CustomDetail != null">
                                <div v-html="item.objData.CustomDetail"></div>
                                <template v-if="item.Rm != ''">
                                  <v-divider></v-divider>
                                  {{ item.Rm }}
                                </template>
                              </div>
                            </td>
                            <td>
                              {{ item.Type }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item value="tab-5">
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหาบทความ" v-model="searchJournal"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields2"
                    worksheet="ประวัติบทความ" :name="'ข้อมูลประวัติบทความ คุณ ' + (MeData.length > 0 ? MeData[0].full_Name: '') + '.xls'"
                    v-if="staff_sel != null">
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list three-line subheader>
                  <v-subheader>บทความ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table :headers="JournalHeader" :items="JournalHistory" :sort-by="['date_start']"
                        :sort-desc="[true]" :search="searchJournal">
                        <template v-slot:item="{item}">
                          <tr @click="EditJournal(item)" style="cursor: pointer">
                            <td>
                              {{ item.YearPrint }}
                            </td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.Journal }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
              <v-tab-item value="tab-6">
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <v-text-field label="ค้นหารางวัลพิเศษ" v-model="searchAward"></v-text-field>
                </v-list-item>
                <v-list-item style="margin-top: 25px">
                  <v-spacer></v-spacer>
                  <download-excel class="btn btn-default" :data="json_data" :fields="json_fields3"
                    worksheet="ประวัติรางวัลพิเศษ"
                    :name="'ข้อมูลประวัติรางวัลพิเศษ คุณ ' + (MeData.length > 0 ? MeData[0].full_Name: '') + '.xls'" v-if="staff_sel != null">
                    <v-btn outlined color="green" class="darken-3" @click="ExportData">
                      Export ข้อมูล
                    </v-btn>
                  </download-excel>
                </v-list-item>
                <v-list three-line subheader>
                  <v-subheader>รางวัลพิเศษ</v-subheader>
                  <v-list-item>
                    <v-list-item-content>
                      <!--                    <v-list-item-title>Content filtering</v-list-item-title>-->
                      <!--                    <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>-->
                      <v-data-table :headers="AwardHeader" :items="AwardHistory" :sort-by="['date_start']"
                        :sort-desc="[true]" :search="searchAward">
                        <template v-slot:item="{item}">
                          <tr @click="EditAward(item)" style="cursor: pointer">
                            <td>
                              {{ item.AwYear }}
                            </td>
                            <td>
                              <span style="font-weight: bold;color: #364eff">{{ item.AwName }}</span>
                              <div v-if="item.Rm != '' && item.Rm != null">
                                : {{ item.Rm }}
                              </div>
                            </td>
                            <td>
                              {{ item.AwBy }}
                            </td>
                            <td>
                              {{ item.AwDetail }}
                            </td>
                            <td>
                              {{ item.AwDoc }}
                            </td>
                            <td>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-sheet>


          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="allCoursesDialog" fullscreen scrollable>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="allCoursesDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>คอร์สทั้งหมด</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" lg="2" v-for="(item, index) in CourseInit" :key="'all-course-' + index">
                <v-card class="mb-2">
                  <v-img :src="item.image" height="200px" class="white--text align-end"></v-img>
                  <v-card-title>
                    <span class="font-weight-bold">{{ item.title }}</span>
                  </v-card-title>
                  <v-card-actions class="justify-center">
                    <v-btn color="primary" @click="GetCourseToShow(item)">
                      <v-icon left>mdi-eye</v-icon>
                      ดูรายละเอียด
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLoading" persistent max-width="400px">
        <v-card>
          <v-card-title class="headline">
            <span>กำลังดำเนินการ</span>
          </v-card-title>
          <v-card-text class="text-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-content>
</template>
<script>
// import axios from "axios";
import ConstData from "../const/Const";
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import Const from "@/const/Const";
import Vue from 'vue'

export default {
  name: 'Home',
  Details: true,
  props: {
    msg: String,
    ToggleMenu: String
  },
  data() {
    return {
      allCoursesDialog: false,
      dialogLoading: false,
      dialogTrainData: false,
      tabMenu: '1',
      showPickerSearchDateSTrain: false,
      showPickerSearchDateETrain: false,
      showPickerSearchDateSCommit: false,
      showPickerSearchDateECommit: false,
      showPickerSearchDateSPresent: false,
      showPickerSearchDateEPresent: false,
      showPickerDateS: false,
      showPickerDateE: false,
      showPickerTravelDateS: false,
      showPickerTravelDateE: false,
      showPickerEditDateS: false,
      showPickerEditDateE: false,
      showPickerEditTravelDateS: false,
      showPickerEditTravelDateE: false,
      showPickerLecturerDateStart: false,
      showPickerLecturerDateEnd: false,
      showPickerEditLecturerDateStart: false,
      showPickerEditLecturerDateEnd: false,
      showPickerLecturerDateDocOut: false,
      showPickerEditLecturerDateDocOut: false,
      LecturerDateStart: '',
      LecturerDateEnd: '',
      LecturerTimeStart: '',
      LecturerTimeEnd: '',
      LecturerDateDocOut: '',
      LecturerDocNo: '',
      LecturerPlace: '',
      LecturerInvite: '',
      LecturerHour: '',
      LecturerProjectName: '',
      EditLecturerDateStart: '',
      EditLecturerDateEnd: '',
      EditLecturerTimeStart: '',
      EditLecturerTimeEnd: '',
      EditLecturerDateDocOut: '',
      EditLecturerDocNo: '',
      EditLecturerPlace: '',
      EditLecturerInvite: '',
      EditLecturerHour: '',
      EditLecturerProjectName: '',
      CheckApprove: false,
      btnLoading: false,
      exportExec: false,
      Choice: '0',
      ChoiceExport: [
        {text: 'อบรม, ประชุม, ศึกษา, ดูงาน', value: '0'},
        {text: 'คณะกรรมการ', value: '1'},
        {text: 'วิทยากร, อาจารย์พิเศษ, นำเสนอผลงาน', value: '2'},
        {text: 'บทความ', value: '3'},
        {text: 'รางวัลพิเศษ', value: '4'},
      ],
      dateExStart: '',
      dateExEnd: '',
      dialogExportHR: false,
      ExportXslx: '',
      ExportXslxData: [
        {text: 'ประชุม', value: '15'},
        {text: 'การศึกษา', value: '16'},
        {text: 'ฝึกอบรม', value: '17'},
        {text: 'ดูงาน', value: '18'},
      ],
      json_fields: {
        'ลำดับ': 'index',
        "วันที่": 'date',
        "ประเภท": 'Type',
        "เรื่อง": 'Subject',
        "รายละเอียด": 'Rm',
      },
      json_fields_all: {
        'ลำดับ': 'idx',
        'รหัส': 'perid',
        'ชื่อ-สกุล': 'full_Name',
        "วันที่เริ่มต้น": 'date_start',
        "วันที่สิ้นสุด": 'date_end',
        "ประเภท": 'Type',
        "เรื่อง": 'Subject',
        "รายละเอียด": 'Rm',
      },
      json_Journal_all: {
        'ลำดับ': 'index',
        "ปี": 'YearPrint',
        "รายละเอียด": 'Journal',
        "ชื่อหลัก": 'Author_Detail',
        "รายละเอียด (เพิ่มเติม)": 'Rm',
        "รหัส": 'perid',
        "ชื่อ-สกุล": 'full_Name',
      },
      json_Extra_all: {
        'ลำดับ': 'index',
        "ปี": 'AwYear',
        "ชื่อรางวัล": 'AwName',
        "หน่วยงานที่ให้รางวัล": 'AwBy',
        "งาน / สถานที่มอบ": 'AwDetail',
        "เอกสารอ้างอิง": 'AwDoc',
        "รายละเอียด": 'Rm',
        "รหัส": 'perid',
        "ชื่อ-สกุล": 'full_Name',
      },
      json_fields2: {
        'ลำดับ': 'index',
        "ปี": 'YearPrint',
        "รายละเอียด": 'Journal',
        "ชื่อหลัก": 'Author_Detail',
        "รายละเอียด (เพิ่มเติม)": 'Rm',
      },
      json_fields3: {
        'ลำดับ': 'index',
        "ปี": 'AwYear',
        "ชื่อรางวัล": 'AwName',
        "หน่วยงานที่ให้รางวัล": 'AwBy',
        "งาน / สถานที่มอบ": 'AwDetail',
        "เอกสารอ้างอิง": 'AwDoc',
        "รายละเอียด": 'Rm',
      },
      json_data: [],
      json_Export: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      JoinPerson: [],
      JoinPersonHeader: [
        {text: 'รหัสบุคลากร', value: 'perid'},
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: 'ตำแหน่ง', value: 'pos_name'},
        {text: '', value: 'action'},
      ],
      staffSelToJoin: '',
      searchDateStart: '',
      searchDateEnd: '',
      DumpDataTrain: [],
      DumpDataCommittee: [],
      DumpDataPresent: [],
      SortData: [],
      dialogEditAward: false,
      dialogEditJournal: false,
      searchAward: '',
      searchJournal: '',
      searchPresent: '',
      searchCommit: '',
      searchTrain: '',
      ObjEditData: null,
      FileToShow: [],
      CheckCordi: false,
      ChkEditData: false,
      TypeEdit: '',
      Subject: '',
      Rm: '',
      EditRm: '',
      dumpCommitData: [],
      AwardDump: [],
      AwYear: '',
      AwBy: '',
      AwName: '',
      AwDetail: '',
      AwDoc: '',
      JournalDump: [],
      MainName: 'False',
      YearPrint: '',
      Journal: '',
      Author: false,
      dialogInsertJournal: false,
      dialogInsertAward: false,
      JournalHeader: [
        {text: 'ปี ค.ศ.', value: 'YearPrint'},
        {text: 'รายละเอียด', value: 'Journal'},
        {text: 'ชื่อหลัก', value: 'MainName'},
        {text: '', value: 'action'},
      ],
      JournalHistory: [],
      AwardHeader: [
        {text: 'ปี พ.ศ.', value: 'AwYear'},
        {text: 'ชื่อรางวัล', value: 'AwName'},
        {text: 'หน่วยงานที่ให้รางวัล', value: 'AwBy'},
        {text: 'งาน/ สถานที่มอบ', value: 'AwDetail'},
        {text: 'เอกสารอ้างอิง', value: 'AwDoc'},
        {text: '', value: 'action'},
      ],
      AwardHistory: [],
      dialogShowDetail: false,
      staff_sel_choose: '',
      dumpStaff: [],
      Openfile: ConstData.ConnectionHost + '/rest/files',
      expanded: [],
      singleExpand: true,
      EditWorkTravelDateS: '',
      EditWorkTravelDateE: '',
      WorkTravelDateS: '',
      WorkTravelDateE: '',
      alert: false,
      files: [],
      FileProject: [],
      WorkGroupHeader: [
        {text: 'หัวข้อเรื่อง/หน้าที่', value: 'subject'},
        {text: 'หน้าที่', value: 'type_name'},
        {text: 'รหัสโครงการ', value: 'Project_code'},
        {text: 'วันที่จัดงานเริ่มต้น', value: 'date_start'},
        {text: 'วันที่จัดงานสิ้นสุด', value: 'date_end'},
        {text: 'วันที่เดินทาง', value: 'date_travel_start'},
        {text: 'วันที่กลับ', value: 'date_travel_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'},
        {text: '', value: 'action'},
      ],
      FileHeader: [
        {text: 'ชื่อไฟล์', value: 'name'},
        {text: 'ประเภทไฟล์', value: 'type'},
        {text: '', value: 'action'},
      ],
      WorkGroup: [],
      CheckProjectCode: false,
      CommittType: [],
      EditWorkGroupType: '',
      EditWorkGroupTypeSubject: '',
      EditWorkGroupProjectCode: '',
      EditWorkGroupProjectName: '',
      EditWorkGroupDateS: '',
      EditWorkGroupDateE: '',
      EdittimeSForLecturer: '',
      EdittimeEForLecturer: '',
      WorkGroupType: '',
      WorkGroupTypeSubject: '',
      WorkGroupProjectCode: '',
      WorkGroupProjectName: '',
      WorkGroupDateS: '',
      WorkGroupDateE: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      TrainHistory: [],
      CommitHistory: [],
      PresentHistory: [],
      B_Option: '',
      dialogInsertData: false,
      tab: null,
      CheckAdmin: false,
      dep_sel: '',
      // DepartData: [],
      StaffDataForDep: [],
      dialog: false,
      staff_sel: null,
      TrainHeader: [
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'ชื่อโครงการ', value: 'Subject'},
        {text: 'ประเภท', value: 'Type'},
      ],
      CommitHeader: [
        {text: 'วันที่เริ่มต้น', value: 'BegDate'},
        {text: 'วันที่สิ้นสุด', value: 'EndDate'},
        {text: 'รายละเอียด', value: 'Detail'},
      ],
      CourseInit: [],
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      maintain: false,
      ProjectRecordData: [],
      level: '',
      workAge: [],
      level_position: [],
      mednet: '',
      tabsModel: null,
      bpm: 50,
      headers: [
        {
          text: 'โครงการ',
          value: 'Project_name'
        },
        {
          text: 'เครดิต',
          value: 'General_credit'
        },
        {
          text: 'วันที่',
          value: 'JoinDate'
        }
      ],
      desserts: [
        {
          courseId: '1',
          courseName: 'อบรมภาษา Python',
          credit: '2',
          date: '20 พ.ค. 2563'
        }
      ],
      LevelData: [],
      items: [],
      dense: false,
      selectable: false,
      activatable: true,
      hoverable: true,
      openOnClick: true,
      shaped: true,
      rounded: true,
      selectedColor: 'accent',
      selectedColors: [
        'red',
        'warning lighten-2',
        'accent',
        'teal',
        'success',
      ],
    }
  },
  computed: {
    color() {
      if (this.bpm < 20) return 'red'
      if (this.bpm < 40) return 'orange'
      if (this.bpm < 60) return 'indigo'
      if (this.bpm < 80) return 'teal'
      return 'green'
    },
    bg() {
      return this.background ? 'https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg' : undefined
    },
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      DepartData: 'Depart/getDepart',
      Course: 'Course/getCourse',
      ProjectRecord: 'Project/getProjectRecord',
      projectData: 'Project/getProject',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectRecordData: 'Project/initProjectRecordData',
      initProjectData: 'Project/initProjectData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
      changeTypeProject: 'Project/changeTypeProject',
    }),
    GetPositionToShow() {
      this.level_position = []
      this.items.map((item) => {
        item.children = []
        item.status = 0
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_position_cordi_view/PosCode/' + this.MeData[0].pos_id).then(res_pos => {
        if (res_pos.data) {
          this.items.map((item) => {
            if (res_pos.data.length > 1) {
              res_pos.data.map((pos_item) => {
                if (item.id == pos_item.Position_level_ms_Id) {

                  var DepData = this.DepartData.filter(item => item.dep_id == pos_item.Dep_Code)

                  if (DepData.length > 0) {
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/C_position_cordi_Id/' + pos_item.Id).then(res_course => {
                      if (res_course.data) {
                        this.items.map((item) => {
                          if (res_course.data.length > 1) {
                            this.Course.map((Course_I) => {
                              res_course.data.map((res_c_item) => {
                                if (Course_I.Course_code == res_c_item.Course_code) {
                                  if (item.id == pos_item.Position_level_ms_Id) {
                                    if (DepData[0].dep_id == '35000') {
                                      item.children.push({
                                        id: parseInt(res_c_item.Id),
                                        name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                        course: Course_I,
                                        Dep_Code: DepData[0].dep_id,
                                        C_position_cordi_Id: pos_item.Id,
                                        status: 1,
                                        children: []
                                      })
                                    } else {
                                      item.children.push({
                                        id: parseInt(res_c_item.Id),
                                        name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                        course: Course_I,
                                        Dep_Code: DepData[0].dep_id,
                                        C_position_cordi_Id: pos_item.Id,
                                        status: 1,
                                        children: []
                                      })
                                    }

                                  }
                                }
                              })
                            })
                          } else {
                            this.Course.map((Course_I) => {
                              if (Course_I.Course_code == res_course.data.Course_code) {
                                if (item.id == pos_item.Position_level_ms_Id) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: parseInt(res_course.data.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: pos_item.Id,
                                      status: 1,
                                      children: []
                                    })
                                  } else {
                                    item.children.push({
                                      id: parseInt(res_course.data.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: pos_item.Id,
                                      status: 1,
                                      children: []
                                    })
                                  }
                                }
                              }
                            })
                          }
                        })

                        this.level_position = this.items.filter((item) => item.children.length > 0)
                      }
                    })
                  }

                }
              })
            } else {
              if (item.id == res_pos.data.Position_level_ms_Id) {
                var DepData = this.DepartData.filter(item => item.dep_id == res_pos.data.Dep_Code)

                if (DepData.length > 0) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_course_posi_cordi/C_position_cordi_Id/' + res_pos.data.Id).then(res_course => {
                    if (res_course.data) {
                      this.items.map((item) => {
                        if (res_course.data.length > 1) {
                          this.Course.map((Course_I) => {
                            res_course.data.map((res_c_item) => {
                              if (Course_I.Course_code == res_c_item.Course_code) {
                                if (item.id == res_pos.data.Position_level_ms_Id) {
                                  if (DepData[0].dep_id == '35000') {
                                    item.children.push({
                                      id: parseInt(res_c_item.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: res_pos.data.Id,
                                      status: 1,
                                      children: []
                                    })
                                  } else {
                                    item.children.push({
                                      id: parseInt(res_c_item.Id),
                                      name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                      course: Course_I,
                                      Dep_Code: DepData[0].dep_id,
                                      C_position_cordi_Id: res_pos.data.Id,
                                      status: 1,
                                      children: []
                                    })
                                  }
                                }
                              }
                            })
                          })
                        } else {
                          this.Course.map((Course_I) => {
                            if (Course_I.Course_code == res_course.data.Course_code) {
                              if (item.id == res_pos.data.Position_level_ms_Id) {
                                if (DepData[0].dep_id == '35000') {
                                  item.children.push({
                                    id: parseInt(res_course.data.Id),
                                    name: Course_I.Course_name + '<span style="font-weight: bold;color: #6091ff"> ( ' + DepData[0].dep_name + ' ) </span> ',
                                    course: Course_I,
                                    Dep_Code: DepData[0].dep_id,
                                    C_position_cordi_Id: res_pos.data.Id,
                                    status: 1,
                                    children: []
                                  })
                                } else {
                                  item.children.push({
                                    id: parseInt(res_course.data.Id),
                                    name: Course_I.Course_name + '<span style="font-weight: bold;color: #42b983"> ( หน่วยงาน : ' + DepData[0].dep_name + ' ) </span> ',
                                    course: Course_I,
                                    Dep_Code: DepData[0].dep_id,
                                    C_position_cordi_Id: res_pos.data.Id,
                                    status: 1,
                                    children: []
                                  })
                                }
                              }
                            }
                          })
                        }
                      })

                      this.level_position = this.items.filter((item) => item.children.length > 0)
                    }
                  })
                }

              }
            }
          })

        } else {
          this.items.map((item) => {
            item.name = item.LevelName
            item.children = []
          })
        }
      })
    },
    DaysInMonth(date2_UTC) {
      var monthStart = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth(), 1);
      var monthEnd = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth() + 1, 1);
      var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
      return monthLength;
    },
    getAge(date_1, date_2) {
      //convert to UTC
      var arrayWorkSummary = [];
      var date2_UTC = new Date(Date.UTC(date_2.getUTCFullYear(), date_2.getUTCMonth(), date_2.getUTCDate()));
      var date1_UTC = new Date(Date.UTC(date_1.getUTCFullYear(), date_1.getUTCMonth(), date_1.getUTCDate()));


      //--------------------------------------------------------------
      var days = date2_UTC.getDate() - date1_UTC.getDate();
      if (days < 0) {

        date2_UTC.setMonth(date2_UTC.getMonth() - 1);
        days += this.DaysInMonth(date2_UTC);
      }
      //--------------------------------------------------------------
      var months = date2_UTC.getMonth() - date1_UTC.getMonth();
      if (months < 0) {
        date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
        months += 12;
      }
      //--------------------------------------------------------------
      var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();

      arrayWorkSummary.push(years);
      arrayWorkSummary.push(months);
      arrayWorkSummary.push(days);

      return arrayWorkSummary;
    },
    getCousetInit() {
       axios
          .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
            queryName: "getCourseInitSettingByUser",
            param: btoa(
              JSON.stringify({
                uid: this.MeData[0].perid,
              })
            ),
          }).then((response) => {
            if (response.data.length > 0) {
              this.CourseInit = response.data;
              /* this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              })
              this.CourseInit.push({
                ...response.data[0],
              }) */
            } else {
              this.CourseInit = [];
            }
          })
    },
    GetCourseToShow(item) {
      window.open(item.url, '_blank');
    },
    TrainDataToShow() {
      this.dialogLoading = true;
      this.TrainHistory = []
      this.CommitHistory = []
      this.PresentHistory = []
      this.JournalHistory = []
      this.JournalHistory = []
      this.AwardHistory = []
      this.DumpDataTrain = []
      this.DumpDataCommittee = []
      this.DumpDataPresent = []
      axios
      .post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
        queryName: "getTrainDataByUser",
        param: btoa(
          JSON.stringify({
            uid: this.MeData[0].perid,
          })
        ),
      }).then((response) => {
        if (response.data) {
          this.TrainHistory = response.data.Train
          this.CommitHistory = response.data.Committee
          this.PresentHistory = response.data.Presentation
          this.JournalHistory = response.data.Journal
          this.AwardHistory = response.data.Award
          this.dialogLoading = false;
          this.dialogTrainData = true;
        } else {
          this.dialogLoading = false;
          this.$swal.fire({
            icon: 'info',
            title: 'ไม่มีข้อมูลการอบรม, ประชุม, ศึกษา, ดูงาน',
          });
        }
      }).catch((error) => {
        console.error(error);
        this.dialogLoading = false;
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถดึงข้อมูลการอบรม, ประชุม, ศึกษา, ดูงานได้ โปรดลองอีกครั้ง',
        });
      });
    },
    RestorePresent() {
      if (this.DumpDataPresent.length > 0) {
        this.PresentHistory = this.DumpDataPresent
      }
    },
    RestoreCommitt() {
      if (this.DumpDataCommittee.length > 0) {
        this.CommitHistory = this.DumpDataCommittee
      }
    },
    RestoreTrain() {
      if (this.DumpDataTrain.length > 0) {
        this.TrainHistory = this.DumpDataTrain
      }
    },
    filterDate(param) {
      switch (param) {
        case '0':
          if (this.DumpDataTrain.length == 0) {
            this.DumpDataTrain = this.TrainHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.TrainHistory = this.DumpDataTrain.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        case '1':
          if (this.DumpDataCommittee.length == 0) {
            this.DumpDataCommittee = this.CommitHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.CommitHistory = this.DumpDataCommittee.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        case '2':
          if (this.DumpDataPresent.length == 0) {
            this.DumpDataPresent = this.PresentHistory
          }
          if (this.searchDateStart != '' && this.searchDateEnd == '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_start >= this.searchDateStart)
          } else if (this.searchDateStart == '' && this.searchDateEnd != '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_end <= this.searchDateEnd)
          } else if (this.searchDateStart != '' && this.searchDateEnd != '') {
            this.PresentHistory = this.DumpDataPresent.filter(item => item.date_start >= this.searchDateStart && item.date_end <= this.searchDateEnd)
          }
          break
        default :
          break
      }
    },
    ExportData() {
      this.json_data = []
      switch (this.tab) {
        case 'tab-2':
          if (this.TrainHistory.length > 0) {
            this.TrainHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-3':
          if (this.CommitHistory.length > 0) {
            this.CommitHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-4':
          if (this.PresentHistory.length > 0) {
            this.PresentHistory.map((item, idx) => {
              if (item.date_end != '0000-00-00') {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start)) + ' - ' + (Vue.filter('DateToThai')(item.date_end)),
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: idx + 1,
                  date: (Vue.filter('DateToThai')(item.date_start))
                })
              }
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-5':
          if (this.JournalHistory.length > 0) {
            this.JournalHistory.map((item, idx) => {
              this.json_data.push({
                ...item,
                index: idx + 1,
                Author_Detail: ((item.Author == '0') ? 'ไม่ใช่' : 'ใช่'),
              })
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        case 'tab-6':
          if (this.AwardHistory.length > 0) {
            this.AwardHistory.map((item, idx) => {
              this.json_data.push({
                ...item,
                index: idx + 1,
              })
            })
            this.json_data.sort((a, b) => (a.date_start > b.date_start) ? 1 : ((b.date_start > a.date_start) ? -1 : 0))
          }
          break
        default:
          break
      }
    },
    openAllCoursesDialog() {
      this.allCoursesDialog = true;
    },
    init() {
      this.initCourseData()
      this.initProjectData({
        perid: this.MeData[0].perid
      })
      this.getCousetInit()
      this.initDepartData().then(res => {
        if (res) {
          this.GetPositionToShow()
        }
      })
      this.initProjectRecordData(this.MeData[0]).then(res => {
        if (res) {
          this.ProjectRecordData = []
          this.ProjectRecord.map(P_record_i => {
            this.projectData.map(project_i => {
              if (P_record_i.Project_code == project_i.Project_code) {
                this.Course.map(course_i => {
                  if (project_i.Course_code == course_i.Course_code) {
                    this.ProjectRecordData.push({
                      ...project_i,
                      ...course_i,
                      ...P_record_i,
                      JoinDate: P_record_i.Create_Time
                    })
                  }
                })
              }
            })
          })
        }
      })
    }
  },
  async mounted() {
    this.changeColor({ color: Const.defaultColorApp });
    this.changeHeaderName({ headerName: Const.defaultHeaderApp });
    this.changeTypeProject({ type: null });

    try {
      // Initialize essential user data
      await this.initMeData();
      if (!this.MeData || this.MeData.length === 0) {
        throw new Error("User data (MeData) is not available or empty after initialization.");
      }
      const userPerId = this.MeData[0].perid;

      // Fetch permission data
      await this.getIgnoreMenuPermissData({
        perid: userPerId,
        page_id: '1' // Assuming '1' is the page_id for Home
      });
      await this.getMenuPermissData();

      // Determine if the user can access the page
      const canAccessPage = (
        (this.MenuPermiss && this.MenuPermiss.some(item => item.page_id == '1' && item.page_status == '1')) ||
        (this.IgnoreMenuPermiss && this.IgnoreMenuPermiss.some(item => item.perid == userPerId))
      );

      if (canAccessPage) {
        this.maintain = false;

        // Load page-specific data
        await this.initlevelData();
        if (this.levelData && this.MeData[0]) {
          this.level = this.levelData.filter(item => item.LevelCode == this.MeData[0].lv_id);
          // Initialize this.items based on levelData
          this.items = this.levelData.map((level_i, idx) => ({
            ...level_i,
            id: idx,
            name: level_i.LevelName,
            status: 0,
            children: [] // Children will be populated by GetPositionToShow (called in this.init)
          }));
        } else {
          console.warn("Level data or MeData not fully available for processing levels and items.");
        }

        if (this.MeData[0].date_in) {
          this.workAge = this.getAge(new Date(this.MeData[0].date_in), new Date());
        }
        this.mednet = `${ConstData.ConnectionHost}/ImageMED.php?pid=${userPerId}`;

        // Call the main initialization method for the component's content.
        this.init();

      } else {
        // Page is under maintenance or user lacks permission
        const maintenanceEntry = this.MenuPermiss && this.MenuPermiss.find(item => item.page_id == '1' && item.page_message != null);
        this.pageMessage = maintenanceEntry ? maintenanceEntry.page_message : 'ปิดปรับปรุงระบบชั่วคราว';
        this.maintain = true;
      }

    } catch (error) {
      console.error("Error in Home.vue mounted hook:", error);
      // Fallback to a generic error message or a maintenance message if available
      const maintenanceEntry = this.MenuPermiss && this.MenuPermiss.find(item => item.page_id == '1' && item.page_message != null);
      this.pageMessage = maintenanceEntry ? maintenanceEntry.page_message : 'เกิดข้อผิดพลาดในการโหลดข้อมูลหน้าหลัก';
      this.maintain = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
